/// <reference types="@quan/env" />

import {
  HEADER_AUTHORIZATION_KEY,
  HEADER_DEVICE_SID_KEY,
  HEADER_VERSION_KEY,
} from '@quan/services';
import { loggerClientBrowser } from '@quan/logger';
import type { IExportData } from '@quan/logger/typings/core/types/log';

import { isProductionMode } from './condition-env';
import type { RegisterOptions } from './interface';

export default function register(options?: RegisterOptions) {
  const _env = {
    ...env,
    ...process?.env,
  };

  try {
    loggerClientBrowser.mount({
      logLevel: isProductionMode('ERROR', 'DEBUG'),
      catType: isProductionMode('term_report', 'term_debug'),
      autoUpload: true,
      processRequestOptions(res) {
        res.headers!.set(HEADER_VERSION_KEY, `${_env?.PKGName || 'quan-root'}-${_env?.mode}`);
        res.headers!.set(HEADER_DEVICE_SID_KEY, _env?.deviceSid!);
        if (res.body) {
          const sid = (JSON.parse(res.body) as IExportData[])?.find?.((v) => v.ext?.sid)?.ext?.sid;
          if (sid) {
            res.headers!.set(HEADER_AUTHORIZATION_KEY, sid);
          }
        }
        return res;
      },
      processRequestData(res) {
        return res.map((v) => {
          v[HEADER_DEVICE_SID_KEY] = _env?.deviceSid;
          return v;
        });
      },
      ...options?.loggerOptions,
    });
  } catch (e) {
    console.log('pin register error', e);
  }
}
